export default __webpack_public_path__ + "static/media/93070a007effbfd35b1eaba46ab2b4031576069716003.15b6621c.webp";